import React, { Component } from 'react';
import makeCloudinaryUrlForPhoto from  '../../utils/makeCloudinaryUrlForPhoto'

class DishBlock extends Component {
  render() {
    let photo = this.props
    let src = makeCloudinaryUrlForPhoto(photo, {width: 1200})
    // console.log(this.props.className)
    return(
      <article className="item draggable-handle" key={photo.id}>
        <div style={{
              backgroundImage: `url(${src})`
            }}
            className="photo-container"></div>

      </article>
    )
  }
}
export default DishBlock
